import { forwardRef } from "react";
import Slide from "@mui/material/Slide";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import Divider from "@mui/material/Divider";
import DialogTitle from "@mui/material/DialogTitle";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import {
  useGetUserById,
  useAcknowledgeREGENRewards,
} from "../hooks/useMyAccount";
import { checkRewardEligibility } from "../utils/jwt";
import { Link } from "react-router-dom";
import Typography from "@mui/material/Typography";
import { getHasImpersonate } from "../utils/jwt";

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const AcknowledgeREGENRewards = () => {
  const isRewardEligible = checkRewardEligibility();
  const { data, isLoading } = useGetUserById();
  const { acceptedRegenReward, id } = data || {};
  const { mutate } = useAcknowledgeREGENRewards();

  const handleClose = () => {
    if (id) mutate(id);
  };

  return (
    <Dialog
      open={isRewardEligible && !acceptedRegenReward && !getHasImpersonate() && !isLoading}
      TransitionComponent={Transition}
      aria-describedby="terms-and-conditions-alert"
      style={{ zIndex: 1 }}
    >
      <DialogTitle component="h3">REGEN REWARDS TERMS AND CONDITIONS</DialogTitle>
      <Divider />
      <DialogContent>
        <DialogContentText>
          <Typography variant="body1">
            I hereby agree to the terms of the{" "}
            <Link style={{ textDecoration: "underline", color: "var(--blue)" }} to="/regen-resources">
              REGEN Rewards Program
            </Link>
          </Typography>

        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button variant="btn-secondary" onClick={handleClose}>
          Acknowledge
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AcknowledgeREGENRewards;
